import { SystemService } from '@core/services/system/system.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

import { CommonModule } from '@angular/common';
import { Component, Input, effect, inject } from '@angular/core';

@Component({
  selector: 'app-loading-fragment',
  template: `
    <section
      *ngIf="loading"
      class="container-loading-fragment"
      [style.height]="height">
      <img id="logo-img" [src]="logo" alt="logo confear" />
      <p-progressSpinner
        [style]="{ width: '50px', height: '50px' }"
        styleClass="custom-spinner"
        strokeWidth="8"
        fill="transparent"
        animationDuration=".5s"></p-progressSpinner>
    </section>
  `,
  styleUrls: ['./loading-fragment.component.scss'],
  imports: [CommonModule, ProgressSpinnerModule]
})
export class LoadingFragmentComponent {
  @Input() loading: boolean;
  @Input() height;
  logo: string;

  systemService = inject(SystemService);

  constructor() {
    effect(() => {
      const config = this.systemService.configuracao();
      this.logo = `assets/logos${config?.imgLogoLogin}`;
    });
  }
}
